import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import RunResults from './RunResults';
import RunResultsTabState from './RunResultsTabState';

export default class RunResultsTabView extends BufferTabView<RunResultsTabState> {
  render(): this {
    const props = {
      runId: this.model.get('runId'),
    };
    renderToDOM(
      <div className="react-tab-container">
        <RunResults {...props} />
      </div>,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<RunResultsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

RunResultsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
